import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Redirect from "./components/redirect";
import Redirect2 from "./components/redirect2";
import Landing from "./components/landing";
import "./globalStyles.css";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/referral" element={<Redirect />} />
        <Route path="/referral2" element={<Redirect2 />} />
      </Routes>
    </Router>
  );
}
